<div class="filters">
  <form>
    <ng-container *ngFor="let filter of statisticsFiltersData; let i = index">
      <!-- start filter card -->
      <div class="filter-card" (click)="onSelectFilter(filter)" [attr.activeFilter]="selectedFilter.value == filter?.cardAction ? 'active' : ''">
        <span>{{filter?.label}}</span>
        <!-- start statistics percent -->
        <div class="card-statistics">
          <span class="statistics-number ">{{filter?.statistics | numberFormat}}</span>
          <span class="percentage" [attr.percentage]="filter?.statisticsPercentage >= 0 ? 'up' : 'down'">
            {{Math.abs(filter?.statisticsPercentage) | numberFormat}}%
            <mat-icon>{{filter?.statisticsPercentage >= 0 ? 'arrow_upward' : 'arrow_downward'}}</mat-icon>
          </span>
        </div>
        <!-- end statistics percent -->
      </div>
      <!-- end filter card -->
    </ng-container>
  </form>
</div>
